import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = ['Fermentación y tiempos para lograr sabor auténtico', 'Fibras inteligentes (como gel de psyllium) para estructura perfecta', 'Combinaciones que dan miga húmeda, elasticidad y alveolado', 'Sin gomas industriales que caen pesadas'];
  return <section ref={ref} className="w-full bg-cream px-4 py-16 md:py-24" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-103">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-104">
            Soy la Chef Martina Guez
          </h2>
          <p className="font-body text-lg md:text-xl text-brown/80 max-w-3xl mx-auto" data-id="element-105">
            Y me dedico profesionalmente a{' '}
            <span className="font-semibold text-terracotta" data-id="element-106">
              reconstruir panadería argentina
            </span>{' '}
            para cuerpos que no negocian con el gluten o con el azúcar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-107">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-brown mb-6 text-center" data-id="element-108">
            Método de Leudado Biológico
          </h3>

          <p className="font-body text-lg text-brown/80 mb-8 text-center max-w-2xl mx-auto" data-id="element-109">
            No es magia. Es ciencia aplicada a la cocina. Te enseño a usar:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-110">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.1
          }} className="flex items-start gap-4" data-id="element-111">
                <CheckCircleIcon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-112" />
                <p className="font-body text-base md:text-lg text-brown" data-id="element-113">
                  {feature}
                </p>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="font-body text-xl md:text-2xl text-center text-terracotta font-semibold mt-10" data-id="element-114">
            El resultado: panes que se sienten pan. Pizzas que se doblan.
            Facturas que emocionan.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}